export default {
  data() {
    return {
      lastSizeSelected: null,
      showMsgTallaNotSelected: null,
      colorIndexSetted: null,
      loading: false,
      lastInfo: null,
      hasStock: true,
      lastNoStock: false,
      newVariantTallaList: null,
      backupProduct: null,
      lastSearch: []
    }
  },

  methods: {
    resetModal: function () {
      this.lastSizeSelected = null
      this.showMsgTallaNotSelected = null
      this.colorIndexSetted = null
      this.loading = false
      this.lastInfo = null
      this.hasStock = true
      this.lastNoStock = false
      this.newVariantTallaList = null
      this.backupProduct = null
      this.lastSearch = []
    },
    
    getVariantUrl(url, index) {
      var colorIndex = index
      var finalVariant
      if(!!colorIndex && colorIndex > -1) {
        var logic = _.bind(function(checkTalla) {
          return _.find(this.computedQuickProduct.product.variantMatrix[colorIndex].elements , _.bind(function (variant) {
            return checkTalla ?
            !!variant.variantOption.stock.stockLevel && variant.variantValueCategory.name == _.first(this.$refs.tallael).options[_.first(this.$refs.tallael).selectedIndex].text :
            !!variant.variantOption.stock.stockLevel
          }, this))
        }, this)
        finalVariant = logic(true) || logic(false)
      }
      !!finalVariant ? finalVariant.variantOption.url = 'p/' + finalVariant.variantOption.code  + '/quickView' : _.noop()
      return _.get(finalVariant, 'variantOption.url', url)
    },

    showLastNoStock() {
      this.lastNoStock = true
    },

    quickViewReference (url, index, programatically, calledBySize) {
      this.lastNoStock = false
      this.showMsgTallaNotSelected = null;
      // la setteamos para luego asignarsela en la variantlist que se usa para mostrar el color selected comparando urls
      var finalUrl = this.getVariantUrl(url, index)
      this.loading = true
      this.$http.get(finalUrl).then(response => {
        var thisproduct = response.body.product;
        var that = this
        if(response.body.productVariantMatrix && response.body.productVariantMatrix.length > 0){
          response.body.varianttallalist = [];
          for (var i = 0; i < response.body.productVariantMatrix.length; i++) {
            var thisvariant = response.body.productVariantMatrix[i];
            if(thisvariant.variantOption.code == response.body.product.code){
              for (var j = 0; j < thisvariant.elements.length; j++) {
                var thiselement = thisvariant.elements[j];
                if(thiselement.parentVariantCategory.code == 'talla') {
                  response.body.varianttallalist.push({
                    name: thiselement.variantValueCategory.name,
                    // selected: thiselement.variantOption.code == thisproduct.code ? 'selected' : '',
                    url: thiselement.variantOption.code + '/quickView',
                    disabled: that.isGiftCard(response.body.product) || _.find(response.body.product.baseOptions[0].options, _.bind(function(option) {
                        return !!option.stock.stockLevel && (option.code == this.variantOption.code)
                    }, thiselement)) ? false : true
                  })
                }
              }
            }
          }
        }
        // Actualizamos Info de variantes
        this.lastInfo = response.body
        var newElHasStock = (response.body.product.stock.stockLevel > 0)
        this.backupProduct = response.body

        if(!this.isGiftCard(response.body.product) && newElHasStock || this.isGiftCard(response.body.product) || !response.body.product.baseOptions.length) {
          //Seteo last size selected text
          (_.first(this.$refs.tallael) && _.first(this.$refs.tallael).selectedIndex > 0) && (this.lastSizeSelected = _.first(this.$refs.tallael).options[_.first(this.$refs.tallael).selectedIndex].text)

          this.quickProduct = response.body

          if(!!this.quickProduct.varianttallalist) {
            this.quickProduct.varianttallalist = _.concat([{
              name: 'Selecciona',
              value: null,
              disabled: true,
              url: ''
            }], this.quickProduct.varianttallalist)
            var indexTalla = _.findIndex(this.quickProduct.varianttallalist, _.bind(function(variant) {
              return variant.name == this.lastSizeSelected
            }, this))
            this.quickProduct.varianttallalist[indexTalla > -1 ? indexTalla : 0].selected = true
            indexTalla <= 0 ? this.lastSizeSelected = null : _.noop()
          }

          this.quickProduct.product.imageToShow = _.find(this.quickProduct.product.images, function (image) {
            return image.format === 'product'
          })
          this.quickProduct.product.hasDeliveryPickup = _.find(this.quickProduct.product.deliveryModes, function (deliveryMode) {
            return deliveryMode.code === 'pickup'
          })
          this.quickProduct.product.hasDeliveryStandard = _.find(this.quickProduct.product.deliveryModes, function (deliveryMode) {
            return deliveryMode.code === 'standard' || deliveryMode.code === 'free-standard-shipping' || deliveryMode.code === 'express'
          })
          this.quickProduct.product.hasDeliveryPickup = !!this.quickProduct.product.hasDeliveryPickup
          this.quickProduct.product.hasDeliveryStandard = !!this.quickProduct.product.hasDeliveryStandard

          this.$root.$emit('quick-view-open', response.body.product.code)

          this.newVariantTallaList = response.body.varianttallalist
          // Actualizamos el índice de color Seleccionado únicamente cuando lo elegido tiene stock
          _.isInteger(index) && (this.colorIndexSetted = index)

          this.modalReferenceShow = true
        } else {
          calledBySize && (this.newVariantTallaList = response.body.varianttallalist)
          this.lastNoStock = true
          if(!!_.find(this.newVariantTallaList, function (talla) {
            return !talla.disabled
          })) {
            var indexLastSize = _.findIndex(this.newVariantTallaList, _.bind(function(variant) {
              return variant.name == this.lastSizeSelected && !variant.disabled
            }, this))
            if(_.isInteger(indexLastSize)) {
              this.setOptionIndex(indexLastSize)
              this.modalReferenceShow = true
            } else {
              this.selectWithStock()
            }
          } else {
            this.selectWithStock()
          }
        }

        if(programatically) {
          this.setFirstOption()
          this.lastNoStock = true
        }
      }, error => {
        console.error(error)
      }).finally(function () {
        this.loading = false

      })
    },

    setOptionIndex(index) {
      (index > -1) && this.$refs.tallael && this.$refs.tallael[0] && (this.$refs.tallael[0].selectedIndex = index)
    },

    setFirstOption() {
      if(!this.isGiftCard(_.get(this, 'quickProduct.product', _.get(this, 'computedQuickProduct.product')))) {
        setTimeout(_.bind(function () {
          this.$refs.tallael && this.$refs.tallael[0] && (this.$refs.tallael[0].selectedIndex = 0)
          this.lastSizeSelected = null
        }, this), 50)
      }
    },

    changeQuickViewReferenceSelect () {
      this.selectVariant(this.$refs.tallael.value)
      if(this.$refs.tallael.value) {
        this.quickViewReference(this.$refs.tallael.value, null, false, true)
      } else {
        this.quickViewReference('p/'+this.$refs.tallael[0].value, null, false, true)
      }
    },

    isGiftCard(product) {
      return (new RegExp("gift", "i").test(_.get(product, "baseOptions[0].variantType")))
    },

    selectWithStock() {
      console.log('selectWithStock');
      var partOfUrl = (_.has(this.backupProduct, 'product.baseProduct') && _.has(this.backupProduct, 'product.baseOptions.[0].options')) ?
      _.get(_.bind(function () {
        var logic = _.bind(function (priority) {
          return _.find(_.clone(_.get(this.backupProduct, 'product.baseOptions[0].options')).reverse(), (_.bind(function(option) {
            return !!option.stock.stockLevel && (priority ? _.find(_.get(_.find(this.backupProduct.productVariantMatrix, _.bind(function (variant) {
              return _.get(this, 'backupProduct.product.code') == variant.variantOption.code
            }, this)), 'elements'), _.bind(function (element) {
              return element.variantOption.code == this.code
            }, option)) : true)
          }, this)))
        },this)
        return logic(true) || logic(false)
      },this)(), 'code') : false
      if(partOfUrl) {
        this.quickViewReference(this.urlprefix + partOfUrl + '/quickView', null, true)
      } else {
        this.quickProduct = this.backupProduct
        this.quickProduct.product.imageToShow = _.find(this.quickProduct.product.images, function (image) {
          return image.format === 'product'
        })
        this.modalReferenceShow = true
      }
    }
  },

  computed: {
    variantList() {
      var that = this
      var lastProduct = this.lastInfo || this.computedQuickProduct
      return _.map((_.get(lastProduct, 'variantlist')), _.bind(function(variant, index) {
        let retVariant = _.clone(variant)
        var logic = function (that, checkTalla, checkSameUrl) { // Esta lógica devuelve un elemento si encuentra stock
          return _.find(lastProduct.product.baseOptions[0].options, function(option) { // Itero las base options
            return _.isEmpty(lastProduct.productVariantMatrix[index].elements) ? // Pregunto si tiene talles en el color actual iterado
              (!!option.stock.stockLevel && (option.code == lastProduct.productVariantMatrix[index].variantOption.code)) : // Sino tiene variantes cruzo el dato del element del variant matrix con la option que coincida el id para chequear su stock
             _.find(lastProduct.productVariantMatrix[index].elements, _.bind(function(element) { // Si tiene variantes itera sobre los talles del variant matrix que enten en el indice actual
               return checkTalla ? !!this.stock.stockLevel && (this.code == element.variantOption.code) && ( _.get(element, 'variantValueCategory.name') == that.tallaTextBackup) : // Si !!checkTalla priorizo que el name de la talla iterada coincida con el text backup de talla
               checkSameUrl ? !!this.stock.stockLevel && (this.code == element.variantOption.code) && (lastProduct.product.url == this.url) : // Si !!checkSameUrl priorizo que el name de la talla iterada coincida con el text backup de talla
               !!this.stock.stockLevel && (this.code == element.variantOption.code) // En caso final solo validamos que la variante iterada tenga stock
            },option))
          })
        }

        var urlfinal = _.get(logic(this, true) || logic(this, false, true) || logic(this), 'url')
        retVariant.productStyleUrl = urlfinal ? function () {
          urlfinal =  urlfinal.split('/p/')[1] + '/quickView'
          return urlfinal
        }() : null
        return retVariant
      },this))
    },

    variantTallaList() {
      return _.get(this, 'newVariantTallaList') || _.get(this, 'computedQuickProduct.varianttallalist')
    }
  },

  watch: {
    variantTallaList(newVal) {
      if(_.find(newVal, _.bind(function(talla) {
        return talla.selected && talla.disabled
      },this))) {
        this.setFirstOption()
      }
    },

    variantList(newVal) {
      var product = _.get(this, 'quickProduct.product', _.get(this, 'computedQuickProduct.product'))
      if(!!product) {
        var hasNoBaseStock = !_.get(product, 'baseOptions.length') && !_.get(product, 'stock.stockLevel')
        if(!this.isGiftCard(product) && !!this.variantList.length && product && !(_.find(this.variantList, _.bind(function(variant) {
          return !!variant.productStyleUrl
        }, this))) || hasNoBaseStock) {
          this.hasStock = false
        }
      } else {
        this.selectWithStock()
      }
    },

    variantSelected(newVal) {
      this.colorIndexSetted = _.findIndex(this.variantList, _.bind(function(variant) {
        return variant.url == this.variantSelected
      }, this))
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/mixins/quickProductMixin.js